import DeveloperConsole from './DeveloperConsole';

export default DeveloperConsole;
